/* eslint-disable */
import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';

const mediaQuery = '(max-width: 1000px)';
const mediaQueryList = window.matchMedia(mediaQuery);

const makeAllButCurrentSlideInert = function makeAllButCurrentSlideInert() {
    const currentSlideEl = this.slides[this.realIndex];
    this.slides.forEach((slide, index) => {
        if (slide !== currentSlideEl) {
            slide.setAttribute('inert', '');
        } else {
            slide.removeAttribute('inert');
        }
    });
};

function createSwiper() {
    const swiperWrapper = document.querySelectorAll('.realisations-carousel-wrapper');
    swiperWrapper.forEach((element, index) => {
        const elSwiperContent = element.querySelector('.swiper-content');
        let swiperContent = elSwiperContent.swiper;
        const elSwiperMobileNav = element.querySelector('.swiper-mobile-nav');
        let swiperMobileNav = elSwiperMobileNav.swiper;
        const elSwiperNav = element.querySelector('.swiper-nav');
        let swiperNav = elSwiperNav.swiper;
        // if swiper exists, destroy it so we can create a new one
        if (typeof swiperContent !== 'undefined') {
            swiperContent.destroy(true, true);
        }
        if (mediaQueryList.matches) {
            if (typeof swiperNav !== 'undefined') {
                swiperNav.destroy(true, true);
            }
            swiperMobileNav = new Swiper(elSwiperMobileNav, {
                spaceBetween: 5,
                slidesPerView: 3,
                centeredSlides: true,
                centeredSlidesBounds: true,
                speed: 500,
                keyboard: {
                    enabled: true,
                },
                breakpoints: {
                    768: {
                        spaceBetween: 10,
                    },
                },
            });
            swiperContent = new Swiper(elSwiperContent, {
                modules: [Navigation, Thumbs],
                slidesPerView: 1,
                centeredSlides: true,
                speed: 500,
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    nextEl: document.querySelector('.swiper-nav-container-mobile .slider-button-next'),
                    prevEl: document.querySelector('.swiper-nav-container-mobile .slider-button-prev'),
                },
                thumbs: {
                    swiper: swiperMobileNav,
                },
                on: {
                    init() {
                        makeAllButCurrentSlideInert.call(this);
                    },
                    slideChange() {
                        makeAllButCurrentSlideInert.call(this);
                    },
                    slideChangeTransitionEnd() {
                        const currentSlideEl = this.slides[this.realIndex];
                    },
                },
            });
            swiperContent.on('slideChangeTransitionStart', function() {
                swiperMobileNav.slideTo(swiperContent.activeIndex);
            });
            swiperMobileNav.on('transitionStart', function(){
                swiperContent.slideTo(swiperMobileNav.activeIndex);
            });
        } else {
            if (typeof swiperMobileNav !== 'undefined') {
                swiperMobileNav.destroy(true, true);
            }
            swiperNav = new Swiper(elSwiperNav, {
                direction: 'vertical',
                spaceBetween: 10,
                slidesPerView: 3,
                centeredSlides: true,
                centeredSlidesBounds: true,
                speed: 1000,
                keyboard: {
                    enabled: true,
                },
            });
            swiperContent = new Swiper(elSwiperContent, {
                modules: [Navigation, Thumbs],
                slidesPerView: 1,
                direction: 'vertical',
                autoHeight: true,
                centeredSlides: true,
                speed: 1000,
                mousewheel: true,
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    nextEl: document.querySelector('.swiper-nav-container .slider-button-next'),
                    prevEl: document.querySelector('.swiper-nav-container .slider-button-prev'),
                },
                thumbs: {
                    swiper: swiperNav,
                },
                on: {
                    init() {
                        makeAllButCurrentSlideInert.call(this);
                    },
                    slideChange() {
                        makeAllButCurrentSlideInert.call(this);
                    },
                    slideChangeTransitionEnd() {
                        const currentSlideEl = this.slides[this.realIndex];
                    },
                },
            });
            swiperContent.on('slideChangeTransitionStart', function() {
                swiperNav.slideTo(swiperContent.activeIndex);
            });
            swiperNav.on('transitionStart', function(){
                swiperContent.slideTo(swiperNav.activeIndex);
            });
        }
    });
}
if (document.querySelector('.realisations-carousel-wrapper')) {
    createSwiper();
    mediaQueryList.addEventListener('change', (event) => {
        createSwiper();
    });
}
